import TabPage from "./TabPage";

const ChallengeTypes = () => <TabPage tabKey="challengeTypes" />;

export default ChallengeTypes;
